import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  Box,
  ButtonBase,
  Grid,
  Hidden,
  Theme,
  Typography,
  createStyles,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';

import DocumentationSrc from '../../../assets/img/DocumentationIcon_grey.svg';
import Payments from '../../../assets/img/PaymentsIcon_grey.svg';
import AssistanceSrc from '../../../assets/img/assistance_grey.svg';
import atenttionSrc from '../../../assets/img/atenttion.svg';
import EndorsementSrc from '../../../assets/img/endorsement_grey.svg';
import faqSrc from '../../../assets/img/faq.svg';
import { ReactComponent as RightArrow } from '../../../assets/img/icon/RightArrow.svg';
import InspectionSrc from '../../../assets/img/inspectionIcon_grey.svg';
import SinisterSrc from '../../../assets/img/sinister_grey.svg';
import SuraCard from '../../../components/SuraCard';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../helpers/dataLayerPush';

const CARDS = [
  {
    image: DocumentationSrc,
    title: 'MIS PÓLIZAS',
    description:
      'Seleccioná la póliza que necesités consultar y accedé para ver más detalle.',
    action: 'Acceder',
    link: '/documentation',
  },
  {
    image: Payments,
    title: 'MIS PAGOS',
    description:
      'Podrás acceder a tus pagos y realizar el pago a través de Mercado Pago.',
    action: 'Informate',
    link: '/account/payments',
  },
  {
    image: AssistanceSrc,
    title: 'PEDIR UNA GRÚA',
    description: 'Solicitá la asistencia que necesités para tu vehículo.',
    action: 'Solicitar',
    link: '/assistance',
  },
  {
    image: SinisterSrc,
    title: 'QUIERO DENUNCIAR UN SINIESTRO',
    description:
      'Denunciá de manera inmediata si sufrís un siniestro con tu vehículo.',
    action: 'Denunciar',
    link: '/sinister',
  },
  {
    doubleLine: true,
    image: EndorsementSrc,
    title: 'MODIFICAR LA PÓLIZA DE TU VEHÍCULO',
    description:
      'Desde acá, podés modificar: Patente, motor o chasis. Suma asegurada. Póliza digital.',
    action: 'Ingresar aquí',
    link: '/endorsements',
  },
  {
    image: InspectionSrc,
    title: 'ACCEDÉ A TUS INSPECCIONES',
    description:
      'Si necesitás coordinar una inspección por tu vehículo siniestrado, hacelo aquí.',
    action: 'Acceder',
    link: '/inspections',
  },
];

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: '#000',
      fontFamily: 'Inter',
      fontWeight: 700,
      fontSize: '14px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px',
      },
    },
    description: {
      color: '#4D4D4D',
      fontWeight: 400,
      fontSize: '16px',
    },
    action: {
      display: 'flex',
      marginLeft: '12px',
      color: '#FA6400',
      fontWeight: 500,
    },
    subtitle: {
      color: '#000',
      fontFamily: 'Inter',
      fontWeight: 700,
      fontSize: '20px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px',
        fontWeight: 400,
      },
    },
    suraCard: {
      [theme.breakpoints.down('sm')]: {
        minHeight: '75px',
      },
    },
    desktopContainer: {
      [theme.breakpoints.up('sm')]: {
        gap: '10px 0px',
      },
    },
    desktopCard: {
      display: 'grid',
      minHeight: '240px',
      '& img': {
        minHeight: '65px',
      },
    },
    cardMobile: {
      '& img': {
        minHeight: '50px',
      },
    },
    cardText: {
      [theme.breakpoints.down('xs')]: {
        width: '70%',
      },
    },
  })
);

const LinkCards = ({
  hasVehicles,
  hasProducts,
  hasSinisterInspections,
  hasAssistance,
}) => {
  // Agregar condición para hasSinisterInspections == true
  const classes = useStyle();
  const { user } = useAuthDataContext();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));

  const cardTag = (card) => {
    if (card.title === 'Mis pagos') {
      dataLayerPush('inicio_mis_pagos', user?.id);
    }
  };

  return (
    <>
      {hasProducts && (
        <Box>
          <Grid item xs={12}>
            <Box className={classes.subtitle} my={2}>
              {' '}
              ¿En qué te ayudamos?{' '}
            </Box>
          </Grid>

          <Grid container className={classes.desktopContainer}>
            {matches ? (
              <>
                {CARDS.filter((card) =>
                  !hasVehicles
                    ? card.title === 'MIS PÓLIZAS' || card.title === 'MIS PAGOS'
                    : card
                ).map(
                  (card: any, index: number) =>
                    (card.title !== 'ACCEDÉ A TUS INSPECCIONES' ||
                      (card.title === 'ACCEDÉ A TUS INSPECCIONES' &&
                        hasSinisterInspections)) &&
                    (card.title !== 'PEDIR UNA GRÚA' ||
                      (card.title === 'PEDIR UNA GRÚA' && hasAssistance)) && (
                      <Grid item xs={12} sm={5} md={3} key={index}>
                        <Box mx={1} mb={1} onClick={() => cardTag(card)}>
                          <ButtonBase
                            component={RouterLink}
                            to={card.link}
                            style={{ display: 'block' }}
                          >
                            <SuraCard
                              style={{ display: 'block', minHeight: '75px' }}
                            >
                              <Box
                                m={1}
                                marginLeft="16px"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Box>
                                    <img
                                      src={card.image}
                                      alt={card.title}
                                      height={50}
                                      width={60}
                                    ></img>
                                  </Box>
                                  <Box ml={3}>
                                    <Typography className={classes.title}>
                                      {card.title}
                                    </Typography>
                                  </Box>
                                </Box>
                                <Box>
                                  {/* <Box style={{ marginRight: '10px' }}> */}
                                  <RightArrow></RightArrow>
                                </Box>
                              </Box>
                            </SuraCard>
                          </ButtonBase>
                        </Box>
                      </Grid>
                    )
                )}
              </>
            ) : (
              CARDS.filter((card) =>
                !hasVehicles
                  ? card.title === 'MIS PÓLIZAS' || card.title === 'MIS PAGOS'
                  : card
              ).map(
                (card: any, index: number) =>
                  (card.title !== 'ACCEDÉ A TUS INSPECCIONES' ||
                    (card.title === 'ACCEDÉ A TUS INSPECCIONES' &&
                      hasSinisterInspections)) &&
                  (card.title !== 'PEDIR UNA GRÚA' ||
                    (card.title === 'PEDIR UNA GRÚA' && hasAssistance)) && (
                    <Grid item xs={12} sm={5} md={3} key={index}>
                      <Box mx={1} mb={1} onClick={() => cardTag(card)}>
                        <ButtonBase
                          component={RouterLink}
                          to={card.link}
                          style={{ width: '100%' }}
                        >
                          <SuraCard className={classes.suraCard}>
                            <Box
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                justifyContent: 'center',
                                margin: '8px 8px 8px 24px',
                              }}
                            >
                              <Box className={classes.desktopCard}>
                                <Box>
                                  <img src={card.image} alt="siniestro"></img>
                                </Box>
                                <Box className={classes.title}>
                                  {card.title}
                                </Box>
                                <Box className={classes.description}>
                                  {card.description}
                                </Box>
                                <Box
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Box style={{ display: 'flex' }}>
                                    <RightArrow></RightArrow>
                                  </Box>
                                  <Box className={classes.action}>
                                    {card.action}
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </SuraCard>
                        </ButtonBase>
                      </Box>
                    </Grid>
                  )
              )
            )}
          </Grid>
        </Box>
      )}

      <Grid item xs={12}>
        <Box className={classes.subtitle} mt={4} mb={2}>
          {' '}
          Resolvemos tus dudas{' '}
        </Box>
      </Grid>

      <Grid container xs={12}>
        {/* Card 1 */}
        <Grid item xs={12} sm={5} md={3}>
          <Box mx={1} mb={1}>
            <ButtonBase
              component={RouterLink}
              to={'/user-faq'}
              style={{ width: '100%' }}
            >
              <SuraCard
                className={classes.suraCard}
                style={{ backgroundColor: '#FA6400' }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'center',
                    margin: '8px 8px 8px 24px',
                  }}
                >
                  <Hidden smUp implementation="css">
                    <Box
                      display="flex"
                      alignItems="center"
                      className={classes.cardMobile}
                    >
                      <Box style={{ display: 'flex', marginRight: '16px' }}>
                        <img src={faqSrc} alt="Preguntas frecuentes"></img>
                      </Box>
                      <Box
                        className={classes.title}
                        style={{ display: 'flex', color: '#ffffff' }}
                      >
                        {'PREGUNTAS FRECUENTES'}
                      </Box>
                    </Box>
                  </Hidden>

                  <Hidden xsDown implementation="css">
                    <Box className={classes.desktopCard}>
                      <Box>
                        <img src={faqSrc} alt="Preguntas frecuentes"></img>
                      </Box>
                      <Box
                        className={classes.title}
                        style={{ color: '#ffffff' }}
                      >
                        {'PREGUNTAS FRECUENTES'}
                      </Box>
                      <Box
                        className={classes.description}
                        style={{ color: '#ffffff' }}
                      >
                        {
                          'Encontrá la respuesta a dudas habituales sobre productos, coberturas de vehículos y siniestros.'
                        }
                      </Box>
                      <Box style={{ display: 'flex', alignItems: 'center' }}>
                        <Box style={{ display: 'flex' }}>
                          <RightArrow></RightArrow>
                        </Box>
                        <Box
                          className={classes.action}
                          style={{ color: '#ffffff' }}
                        >
                          {'Ingresá aquí'}
                        </Box>
                      </Box>
                    </Box>
                  </Hidden>
                </Box>
              </SuraCard>
            </ButtonBase>
          </Box>
        </Grid>

        {/* Card 2 */}
        <Grid item xs={12} sm={5} md={3}>
          <Box mx={1} mb={1}>
            <ButtonBase
              component={RouterLink}
              to={'/user-attention'}
              style={{ width: '100%' }}
            >
              <SuraCard className={classes.suraCard}>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'center',
                    margin: '8px 8px 8px 24px',
                  }}
                >
                  <Hidden smUp implementation="css">
                    <Box
                      display="flex"
                      alignItems="center"
                      className={classes.cardMobile}
                    >
                      <Box style={{ display: 'flex', marginRight: '16px' }}>
                        <img
                          src={atenttionSrc}
                          alt="Atención y consultas"
                        ></img>
                      </Box>
                      <Box
                        className={classes.title}
                        style={{ display: 'flex' }}
                      >
                        {'ATENCIÓN Y CONSULTAS'}
                      </Box>
                    </Box>
                  </Hidden>

                  <Hidden xsDown implementation="css">
                    <Box className={classes.desktopCard}>
                      <Box>
                        <img
                          src={atenttionSrc}
                          alt="Atención y consultas"
                        ></img>
                      </Box>
                      <Box className={classes.title}>
                        {'ATENCIÓN Y CONSULTAS'}
                      </Box>
                      <Box className={classes.description}>
                        {
                          'Podés contactarnos, a través de otros canales, de lunes a viernes de 9 a 18 horas.'
                        }
                      </Box>
                      <Box style={{ display: 'flex', alignItems: 'center' }}>
                        <Box style={{ display: 'flex' }}>
                          <RightArrow></RightArrow>
                        </Box>
                        <Box className={classes.action}>{'Contactános'}</Box>
                      </Box>
                    </Box>
                  </Hidden>
                </Box>
              </SuraCard>
            </ButtonBase>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default LinkCards;
